import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';
const colors = {

  primary: {
    100: "#d2d2d3",
    200: "#a5a5a7",
    300: "#78797a",
    400: "#4b4c4e",
    500: "#1e1f22",
    600: "#18191b",
    700: "#121314",
    800: "#0c0c0e",
    900: "#060607"
  },

  white: {
    100: "#fff"
  },

  grey: {
    100: "#dfe0e2",
    200: "#bfc0c4",
    300: "#a0a1a7",
    400: "#808189",
    500: "#60626c",
    600: "#4d4e56",
    700: "#3a3b41",
    800: "#26272b",
    900: "#131416"
  },

  black: {
    100: "#cececf",
    200: "#9e9e9f",
    300: "#6d6d6e",
    400: "#3d3d3e",
    500: "#0c0c0e",
    600: "#0a0a0b",
    700: "#070708",
    800: "#050506",
    900: "#151618"
  },
  green: {
    100: "#d5fbf4",
    200: "#aaf7e9",
    300: "#80f3de",
    400: "#55efd3",
    500: "#2bebc8",
    600: "#22bca0",
    700: "#1a8d78",
    800: "#115e50",
    900: "#092f28"
  },
  red: {
    100: "#fcdada",
    200: "#fab5b5",
    300: "#f79090",
    400: "#f56b6b",
    500: "#f24646",
    600: "#c23838",
    700: "#912a2a",
    800: "#611c1c",
    900: "#300e0e"
  },
  blue: {
    100: "#daecfc",
    200: "#b5d9fa",
    300: "#90c5f7",
    400: "#6bb2f5",
    500: "#469ff2",
    600: "#387fc2",
    700: "#2a5f91",
    800: "#1c4061",
    900: "#0e2030"
  },
  indigo: {
    100: "#e1dafb",
    200: "#c2b5f8",
    300: "#a490f4",
    400: "#856bf1",
    500: "#6746ed",
    600: "#5238be",
    700: "#3e2a8e",
    800: "#291c5f",
    900: "#150e2f"
  }
}


const theme = createTheme({
  cssVariables: true,
  palette: {
    mode: 'dark',
    error: {
      main: red.A400,
    },
    secondary: {
      main: colors.green[500]
    },

  },
  typography: {

    fontSize: 13,
  },
})

export default theme;